'use strict';

import Vue from 'vue';
import VueMask from 'v-mask';
import Event from './event';
import Config from '../config';
import Module from '../modules/';

export default class {

    constructor() {
        this.token = document.head.querySelector('meta[name="csrf-token"]').content;
        this.event = new Event();
        this.config = Config;
        this.countries = [];
        this.user = [];

        Vue.use(VueMask);
        
        this.slick = new Module.Slick();
        this.header = new Module.Header();
        this.footer = new Module.Footer();
        this.magnificPopup = new Module.MagnificPopup();

        new Module.CountDown();
        new Module.SelectPrice();
        new Module.WatchButton();
        new Module.ProductImage();
        new Module.HighestBid();
        new Module.BidHistory();
        new Module.Login();
        new Module.TopMenu();
        new Module.UserProfile();
        new Module.UserProfileOffcanvas();
        new Module.UserListButtons();
        new Module.MinBid();
    }

    init(url) {
        this.url = url.replace(/\/+$/, "");
        if(this.url == "//localhost:3000") {
            this.surl = url.replace(':3000', ":4000");
        } else {
            this.surl = "https://sock.12meins.at";
        }
        

        // - Trigger cookie consent banner.
        cookieconsent.initialise(Config.cookieconsent);

        this.header.init();
        this.magnificPopup.init();

        this.socket = require('socket.io-client')(this.surl);

            
        this.vue = new Vue({
            el: '#app'
        });
        if($('.popup-gallery').length) {
            $('.popup-gallery').each(function() {
                $(this).magnificPopup({
                    delegate: 'a:not([id=""])',
                    type: 'image',
                    tLoading: 'Loading image #%curr%...',
                    mainClass: 'mfp-img-mobile',
                    gallery: {
                        enabled: true,
                        navigateByImgClick: true,
                        preload: [0,1] // Will preload 0 - before current, and 1 after the current image
                    },
                    image: {
                        tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
                        titleSrc: function(item) {
                            return item.el.attr('title');
                        }
                    }
                });
            });
        }

        this.slick.init();     

        this.watchListData();
    }

    watchListData() {
        new Form().get('/api/product/watch-list')
            .then((response) => {
                this.event.fire('watch-list.data.loaded', response);
            });
    }

    fetchUser() {
        return new Form().get('/api/me')
                .then(user => this.user = user );
    }

}